import { registerAllListeners } from 'registerListeners'
import { CHANGE_ROOT } from '../modules/firebase'
import { SIGN_IN_REQUIRED } from '../modules/auth'
import history from 'store/history'
import { registerBoardingListeners } from '../modules/boarding'
export function extractUserProperties(firebaseUser) {
  const user = {}
  const userProperties = [
    'displayName',
    'email',
    'emailVerified',
    'isAnonymous',
    'photoURL',
    'providerData',
    'providerId',
    'refreshToken',
    'uid',
    'isAdmin'
  ]

  userProperties.map(prop => {
    if (prop in firebaseUser) {
      user[prop] = firebaseUser[prop]
    }
    return prop
  })

  return user
}
export function handleSigninErrorMessage(fbError) {
  let errorMessage
  switch (fbError.code) {
    case 'auth/invalid-email':
      errorMessage = `L'email n'est pas valide`
      break
    case 'auth/user-disabled':
      errorMessage = 'Votre compte a été suspendu, contactez le support'
      break
    case 'auth/user-not-found':
      errorMessage = `Ce compte n'existe pas`
      break
    case 'auth/wrong-password':
      errorMessage = `Le mot de passe n'est pas valide`
      break
    default:
      errorMessage = 'Uncaught Error : ' + fbError.message
  }
  return errorMessage
}
export function handleSignupErrorMessage(fbError) {
  let errorMessage
  switch (fbError.code) {
    case 'auth/invalid-email':
      errorMessage = `Cette adresse email n'est pas valide`
      break
    case 'auth/email-already-in-use':
      errorMessage = 'Cette adresse email est déjà utilisé'
      break
    case 'auth/operation-not-allowed':
      errorMessage = `Une erreur s'est produite, veuillez contacter le support`
      break
    case 'auth/weak-password':
      errorMessage = `Le mot de passe n'est pas assez fort`
      break
    default:
      errorMessage = 'Uncaught Error : ' + fbError.message
  }
  return errorMessage
}
// /* eslint-disable */
export function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

export function validatePassword(pwd) {
  const re = /^.{6,20}$/
  return re.test(pwd)
}

export function boardingWorkflow(auth) {
  return (dispatch, getState) => {
    dispatch(registerBoardingListeners())
    history.replace('/boarding')
  }
}
export function signInWorkflow(auth) {
  return (dispatch, getState) => {
    const location = history.location
    if (auth.rootNode) {
      dispatch({
        type: CHANGE_ROOT,
        payload: auth.rootNode
      })
      dispatch(registerAllListeners())
    }
    if (location.pathname && location.pathname.includes('admin')) {
      if (auth.isAdmin) history.replace(location.pathname)
      else history.replace('/home')
    } else if (location.pathname && location.pathname.includes('signin')) {
      history.replace('/home')
    } else if (location.pathname === '/') {
      history.replace('/home')
    } else {
      history.replace('/home')
    }
  }
}

export function signOutWorkflow() {
  return (dispatch, getState) => {
    dispatch({
      type: SIGN_IN_REQUIRED
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/helpers/authHelpers.js